module.exports = __webpack_public_path__ + "img/casino_thumbnail.5058070f.jpg";